import { render, staticRenderFns } from "./SignIndex.vue?vue&type=template&id=6ee67604&scoped=true&"
import script from "./SignIndex.vue?vue&type=script&lang=js&"
export * from "./SignIndex.vue?vue&type=script&lang=js&"
import style0 from "./SignIndex.vue?vue&type=style&index=0&id=6ee67604&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ee67604",
  null
  
)

export default component.exports